(() => {
  if (window.huedraCardSliders) return;
  window.huedraCardSliders = true;
  const observed = new WeakSet();
  const init = slider => {
    if (!slider.isConnected || slider.swiper || slider.classList.contains('slider_started')) return;
    slider.classList.add('slider_started');
    new Swiper(slider, {
      slidesPerView: 1, speed: 250, spaceBetween: 0,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next-1'),
        prevEl: slider.querySelector('.swiper-button-prev-1')
      },
      pagination: {el: slider.querySelector('.product-card-pagination'), clickable: true}
    });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      init(entry.target);
    });
  }, {rootMargin: '400px 0px'}) : null;
  const scan = root => {
    const sliders = [...(root.querySelectorAll?.('.product-card-js') || [])];
    if (root.matches?.('.product-card-js')) sliders.push(root);
    sliders.forEach(slider => {
      if (observed.has(slider)) return;
      observed.add(slider);
      if (observer && !window.Shopify?.designMode) observer.observe(slider);
      else init(slider);
    });
  };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('huedra:recommendations-ready', event => scan(event.target));
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) scan(node);
  }))).observe(document.getElementById('MainContent') || document.body, {childList:true, subtree:true});
})();
